import { MapfreModalComponent } from '../../section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "underscore";
import { MapfreDesignLibraryComponent } from "./../../../mapfre-design-library.component";
import { Language } from "../../../app.language";
import { ModalOptions } from "../../../_models/modal-options";
import { AcmicService } from "./../../../_services/acmic.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreModalComponent],
  selector: "mapfre-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent extends MapfreDesignLibraryComponent
  implements OnInit {
  localLang = localStorage.getItem("defaultUserLanguage");
  defaultLang: string = this.localLang ? this.localLang : navigator.language; //navigator.language;
  headerHelpModalOptions: ModalOptions;
  @Input() hideModal: boolean;
  @Input() isGuest:boolean;
  @Input() guestTitle = 'Guest Payment';
  padding = false;
  stateCode: string;
  logoPath: string;
  altText: string;
  isAcmic = false;
  helpModalOpened = false;

  constructor(
    public translate: TranslateService,
    public _languages: Language,
    private acmicService: AcmicService
  ) {
    super(translate, _languages);
    this.defaultLang =
      this.defaultLang.indexOf("-") !== -1
        ? this.defaultLang.slice(0, this.defaultLang.indexOf("-")).toUpperCase()
        : this.defaultLang.toUpperCase();
    this.changeLang(this.defaultLang);
  }

  changeLang(lang: string) {
    this.stateCode = this.acmicService.isACMIC() ? "ACMIC" : "MA";
    const selectedObj = _.findWhere(this._languages["lang"][this.stateCode], {
        identifier: "lang"
      });
    if (selectedObj) {
      this.defaultLang = selectedObj["name"];
    } else {
      this.defaultLang = "Choose Language";
    }
    this.setLang(lang);
  }

  onOpenModal(){    
    this.helpModalOpened = true;
    const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
    if(backdrop){
      backdrop.classList.add('header-backdrop')
      backdrop.style.backgroundColor = this.isAcmic ? '#4A4A4AB2' : '#61686C66';
    }
  }

  ngOnInit() {
    if (this.acmicService.isACMIC()) {
      this.isAcmic = true;
      // this.logoPath = "assets/img/logos/AAA-INS-black.png";
      this.logoPath = "assets/img/images/logos/Group 1.svg";
      this.altText = "AAA Insurance";

      this.headerHelpModalOptions = new ModalOptions({
        additionalClasses: "modal-small help eadge-help-modal",
        additionalButtonClasses: "header-flat pd-right-mobile no-margin",
        animatePosition: "top",
        buttonCopy: "MODAL_HELP_TITLE",
        modalId: "helpModal",
        howManyIconsUsed: 1,
        iconClasses: "help_outline",
        iconFamily: "material-icons",
        modalTranslateCopy: "MODAL_HELP_TITLE",
        typeOfModal: "header",
        screenReader: true,
        showIcons: true,
        modalName: 'header_help_modal'
      });

    } else {
      this.logoPath = "assets/public/images/mapfre-logo.svg";
      this.altText = "Mapfre Insurance";

      this.headerHelpModalOptions = new ModalOptions({
        additionalClasses: "modal-small help eadge-help-modal",
        additionalButtonClasses: "no-margin pr-0",
        animatePosition: "top",
        buttonCopy: "MODAL_HELP_TITLE",
        modalId: "helpModal",
        howManyIconsUsed: 1,
        iconClasses: "icon-help-header",
        iconFamily: "icon-help-header",
        modalTranslateCopy: "MODAL_HELP_TITLE",
        typeOfModal: "header",
        screenReader: true,
        showIcons: true,
        modalName: 'header_help_modal'

      });
    }
  }
}
